// extracted by mini-css-extract-plugin
module.exports = {"header":"BuildTypeOverviewTab__header--ig","toggleContainer":"BuildTypeOverviewTab__toggleContainer--Iz"};